import React from 'react';
import { createIcon } from '@chakra-ui/react';

// eslint-disable max-len
export const AirConIcon = createIcon({
  displayName: 'AirConIcon',
  path: (
    <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* eslint-disable max-len */}
      <path
        d="M4.78571 1H19.5C20.0523 1 20.5 1.44772 20.5 2V9.84848C20.5 10.4008 20.0523 10.8485 19.5 10.8485H5.85714M4.78571 10.8485H1.5C0.947715 10.8485 0.5 10.4008 0.5 9.84849V2C0.5 1.44772 0.947715 1 1.5 1H3.71429"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3576 2.96973H16.929M15.8576 2.96973H9.78613M18.0004 10.8485V9.6667M2.28613 10.8485V9.09094C2.28613 8.53865 2.73385 8.09094 3.28613 8.09094H17.0004C17.5527 8.09094 18.0004 8.53865 18.0004 9.09094V9.6667M14.7861 9.6667H2.64328M15.8576 9.6667H18.0004"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0004 12.0303V14M10.5004 12.0303V14M8.00042 12.0303V14M5.85756 12.0303C5.73851 12.5555 5.35756 13.6848 4.78613 14M15.1433 12.0303C15.1433 12.5555 15.3576 13.6848 16.2147 14"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 21 15',
});

export const AirConThinIcon = createIcon({
  displayName: 'AirConThinIcon',
  path: (
    <svg width="48" height="26" viewBox="0 0 48 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.0009 25H2.0009C1.86776 25.0083 1.73441 24.9876 1.61009 24.9392C1.48576 24.8909 1.37344 24.8161 1.2809 24.72C1.1869 24.6259 1.11348 24.5134 1.06528 24.3894C1.01708 24.2655 0.995153 24.1329 1.0009 24V5C1.0009 3.9391 1.42233 2.9217 2.17247 2.1716C2.92262 1.4214 3.94003 1 5.0009 1H43.0009C44.0618 1 45.0792 1.4214 45.8293 2.1716C46.5795 2.9217 47.0009 3.9391 47.0009 5V24C47.0009 24.2652 46.8956 24.5196 46.708 24.7071C46.5205 24.8946 46.2661 25 46.0009 25H44.0009M7.00098 6H41.001M7.00098 11H41.001M9.00098 25H39.001M33.001 15C33.0999 15 33.1966 15.0293 33.2788 15.0843C33.361 15.1392 33.4251 15.2173 33.4629 15.3087C33.5008 15.4 33.5107 15.5006 33.4914 15.5975C33.4721 15.6945 33.4245 15.7836 33.3546 15.8536C33.2846 15.9235 33.1955 15.9711 33.0985 15.9904C33.0016 16.0097 32.901 15.9998 32.8097 15.9619C32.7183 15.9241 32.6402 15.86 32.5853 15.7778C32.5303 15.6956 32.501 15.5989 32.501 15.5C32.501 15.3674 32.5537 15.2402 32.6474 15.1464C32.7412 15.0527 32.8684 15 33.001 15ZM39.001 15C39.0999 15 39.1966 15.0293 39.2788 15.0843C39.361 15.1392 39.4251 15.2173 39.4629 15.3087C39.5008 15.4 39.5107 15.5006 39.4914 15.5975C39.4721 15.6945 39.4245 15.7836 39.3546 15.8536C39.2846 15.9235 39.1955 15.9711 39.0985 15.9904C39.0016 16.0097 38.901 15.9998 38.8097 15.9619C38.7183 15.9241 38.6402 15.86 38.5853 15.7778C38.5303 15.6956 38.501 15.5989 38.501 15.5C38.501 15.3674 38.5537 15.2402 38.6474 15.1464C38.7412 15.0527 38.8684 15 39.001 15Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 48 26',
});

export const PowerPointIcon = createIcon({
  displayName: 'PowerPointIcon',
  path: (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.5 19.5H2C1.44772 19.5 1 19.0523 1 18.5V1.5C1 0.947715 1.44771 0.5 2 0.5H19C19.5523 0.5 20 0.947715 20 1.5V18.5C20 19.0523 19.5523 19.5 19 19.5H11H7.5M5 19.5H5.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10.4997" cy="10.0002" r="6.16667" stroke="currentColor" />
      <path
        d="M12.2416 8.3335L13.8337 10.1853M8.75903 8.3335L7.16699 10.1853M10.4506 12.5002V14.5835"
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 21 20',
});

export const PoolPumpIcon = createIcon({
  displayName: 'PoolPumpIcon',
  path: (
    <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.694336 17.6094H20.533" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M17.7646 12.9955H20.5328V8.84326H17.7646"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9196 6.07508V4.69099H15.4582M13.1514 6.07508V4.69099H13.6127M13.6127 4.69099V1.9228V1C14.72 1.00004 19.3029 1.00007 20.5332 1.00007V2.38416H15.4582V3.30689C15.4582 4.04508 15.4582 4.5372 15.4582 4.69099M13.6127 4.69099H15.4582"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.4964 6.11322C9.48449 6.11222 9.47245 6.11171 9.46029 6.11171L4.38508 6.11133C4.37095 6.11133 4.35682 6.11203 4.34276 6.11344C1.75455 6.37228 0.500039 8.5808 0.5 10.6886C0.499961 12.7964 1.75441 15.005 4.34276 15.2638C4.3568 15.2652 4.3709 15.2659 4.38501 15.2659L4.88431 15.2659C4.8833 15.2779 4.88278 15.29 4.88278 15.3023V17.6091C4.88278 17.8438 5.07306 18.0341 5.30778 18.0341C5.5425 18.0341 5.73278 17.8438 5.73278 17.6091V15.3023C5.73278 15.2901 5.73227 15.278 5.73126 15.266L7.65248 15.2662C7.65148 15.2781 7.65097 15.2901 7.65097 15.3023V17.6091C7.65097 17.8438 7.84125 18.0341 8.07597 18.0341C8.31069 18.0341 8.50097 17.8438 8.50097 17.6091V15.3023C8.50097 15.2901 8.50046 15.2781 8.49947 15.2663L9.46022 15.2664C9.4724 15.2664 9.48447 15.2658 9.4964 15.2648V14.4179C9.48449 14.4169 9.47245 14.4164 9.46029 14.4164L4.40682 14.4159C2.39504 14.2039 1.34997 12.4963 1.35 10.6886C1.35003 8.88097 2.39517 7.17335 4.40679 6.96133L9.46022 6.96171C9.47241 6.96171 9.48447 6.9612 9.4964 6.96019V6.11322ZM12.1919 15.2643C12.2039 15.2654 12.2161 15.2659 12.2284 15.2659H17.7647C17.8775 15.2659 17.9856 15.2211 18.0653 15.1414C18.145 15.0617 18.1897 14.9536 18.1897 14.8409L18.1896 6.53632C18.1896 6.3016 17.9994 6.11133 17.7646 6.11133H12.2284C12.2161 6.11133 12.2039 6.11185 12.1919 6.11288V6.95977C12.2039 6.9608 12.2161 6.96133 12.2284 6.96133H17.3396L17.3397 14.4159H12.2284C12.2161 14.4159 12.2039 14.4164 12.1919 14.4175V15.2643Z"
        fill="currentColor"
      />
      <path
        d="M11.7664 8.84333V5.61377H9.92096V15.7638H11.7664V12.5342M8.0755 8.84333H6.69141M8.0755 11.1502H6.69141M8.0755 12.9956H6.69141"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.07581 6.53638V4.69092H5.30762V6.53638"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="11.6517" cy="10.5736" r="0.346024" fill="currentColor" />
    </svg>
  ),
  viewBox: '0 0 22 19',
});

export const HotWaterIcon = createIcon({
  displayName: 'HotWaterIcon',
  path: (
    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.76461 9.8125H16.2938V11.7867H0.5V9.8125H3.13231"
        stroke="currentColor"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.81641 8.49587C2.5471 6.66938 5.50896 4.84284 8.67504 4.81783M15.636 9.15395C13.8796 5.93428 11.2118 4.7978 8.67504 4.81783M8.67504 4.81783V2C8.67504 1.44772 9.12276 1 9.67504 1H17.6102"
        stroke="currentColor"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6611 13.103V15.7353M13.6611 17.0515V20.9999M11.0288 13.103V14.4192M11.0288 15.7353V17.0515M11.0288 18.3676V20.9999M8.39645 13.103V15.0773M8.39645 16.3934V18.3676M8.39645 19.6838V20.3419M5.76414 13.103V17.0515M5.76414 18.3676V20.3419M3.13184 13.103V15.7353M3.13184 17.0515V17.7096M3.13184 19.0257V20.9999"
        stroke="currentColor"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 19 22',
});

export const LightIcon = createIcon({
  displayName: 'LightIcon',
  path: (
    <svg width="11" height="22" viewBox="0 0 11 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.83333 11.6667V3.33333C1.83333 2.78105 2.28105 2.33333 2.83333 2.33333H3.5C4.05228 2.33333 4.5 2.78105 4.5 3.33333V11.6667V2C4.5 1.44772 4.94772 1 5.5 1H7.5C8.05228 1 8.5 1.44772 8.5 2V11.6667M6.5 11.6667V3M0.5 16V12.6667C0.5 12.1144 0.947714 11.6667 1.5 11.6667H8.83333C9.38562 11.6667 9.83333 12.1144 9.83333 12.6667V16C9.83333 16.5523 9.38562 17 8.83333 17H1.5C0.947715 17 0.5 16.5523 0.5 16Z"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.83333 19H2.5M7.16667 21H3.16667"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 11 22',
});

export const StoveIcon = createIcon({
  displayName: 'StoveIcon',
  path: (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 5.5V1.5C1 0.947715 1.44772 0.5 2 0.5H19C19.5523 0.5 20 0.947715 20 1.5V18C20 18.5523 19.5561 19 19.0038 19C13.5997 19 4.91278 19 1.99334 19C1.44105 19 1 18.5523 1 18V9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="5.37848" cy="3.9024" r="2.18902" stroke="currentColor" strokeWidth="0.5" strokeLinejoin="round" />
      <path
        d="M5.37793 0.731445V2.43876"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.37793 5.36572V7.07304"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.54883 3.90234L6.84151 3.90234"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.1582 3.90234L2.45089 3.90234"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="15.6216" cy="3.65924" r="2.18902" stroke="currentColor" strokeWidth="0.5" strokeLinejoin="round" />
      <path
        d="M15.6221 0.488281V2.1956"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6221 5.12256V6.82988"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.793 3.65918L17.0857 3.65918"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4023 3.65918L12.695 3.65918"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="15.6216" cy="11.4634" r="2.18902" stroke="currentColor" strokeWidth="0.5" strokeLinejoin="round" />
      <path
        d="M15.6221 8.29297V10.0003"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6221 12.9272V14.6346"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.793 11.4634L17.0857 11.4634"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4023 11.4634L12.695 11.4634"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="5.37848" cy="11.4639" r="2.18902" stroke="currentColor" strokeWidth="0.5" strokeLinejoin="round" />
      <path
        d="M5.37793 8.29297V10.0003"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.37793 12.9272V14.6346"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.54883 11.4639L6.84151 11.4639"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.1582 11.4639L2.45089 11.4639"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 15.6099H0.5V19.5123H20.5V15.6099ZM3.91457 18.5368C4.45339 18.5368 4.89018 18.1 4.89018 17.5612C4.89018 17.0224 4.45339 16.5856 3.91457 16.5856C3.37576 16.5856 2.93896 17.0224 2.93896 17.5612C2.93896 18.1 3.37576 18.5368 3.91457 18.5368ZM7.81706 17.5612C7.81706 18.1 7.38027 18.5368 6.84145 18.5368C6.30264 18.5368 5.86584 18.1 5.86584 17.5612C5.86584 17.0224 6.30264 16.5856 6.84145 16.5856C7.38027 16.5856 7.81706 17.0224 7.81706 17.5612ZM14.1585 18.5368C14.6973 18.5368 15.1341 18.1 15.1341 17.5612C15.1341 17.0224 14.6973 16.5856 14.1585 16.5856C13.6197 16.5856 13.1829 17.0224 13.1829 17.5612C13.1829 18.1 13.6197 18.5368 14.1585 18.5368ZM18.0606 17.5612C18.0606 18.1 17.6238 18.5368 17.085 18.5368C16.5462 18.5368 16.1094 18.1 16.1094 17.5612C16.1094 17.0224 16.5462 16.5856 17.085 16.5856C17.6238 16.5856 18.0606 17.0224 18.0606 17.5612ZM9.28042 16.5856C8.7416 16.5856 8.30481 17.0224 8.30481 17.5612C8.30481 18.1 8.7416 18.5368 9.28042 18.5368H11.7194C12.2583 18.5368 12.6951 18.1 12.6951 17.5612C12.6951 17.0224 12.2583 16.5856 11.7194 16.5856H9.28042Z"
        fill="currentColor"
      />
      <rect x="8.79199" y="17.0732" width="3.41463" height="0.97561" rx="0.487805" fill="currentColor" />
      <path d="M1 7.5V7.6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  viewBox: '0 0 21 20',
});

export const EvChargerIcon = createIcon({
  displayName: 'EvChargerIcon',
  path: (
    <svg width="31" height="25" viewBox="0 0 31 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.7391 21.4445C29.0735 21.4445 29.3942 21.3098 29.6307 21.0702C29.8672 20.8306 30 20.5056 30 20.1667V13.7779C30 12.4223 29.4686 11.1223 28.5228 10.1638C27.577 9.20531 26.2941 8.66682 24.9565 8.66682H6.04348C4.70586 8.66682 3.42304 9.20531 2.4772 10.1638C1.53137 11.1223 1 12.4223 1 13.7779V20.1667C1 20.5056 1.13284 20.8306 1.3693 21.0702C1.60576 21.3098 1.92647 21.4445 2.26087 21.4445M28.7391 21.4445H2.26087M28.7391 21.4445V22.7222C28.7391 23.0611 28.6063 23.3861 28.3698 23.6258C28.1334 23.8654 27.8127 24 27.4783 24H24.9565C24.6221 24 24.3014 23.8654 24.065 23.6258C23.8285 23.3861 23.6957 23.0611 23.6957 22.7222V21.4445M2.26087 21.4445V22.7222C2.26087 23.0611 2.39371 23.3861 2.63017 23.6258C2.86663 23.8654 3.18734 24 3.52174 24H6.04348C6.37788 24 6.69859 23.8654 6.93505 23.6258C7.17151 23.3861 7.30435 23.0611 7.30435 22.7222V21.4445M5.41304 8.66683L6.33348 3.09577C6.4394 2.50914 6.74444 1.97853 7.19577 1.59582C7.64711 1.21312 8.2163 1.00243 8.80478 1.00024H22.1952C22.7978 0.991878 23.3834 1.20249 23.846 1.59393C24.3086 1.98536 24.6176 2.53174 24.717 3.13411L25.587 8.66683M5.41304 8.66683L3.52174 6.11129H1.63043C1.46323 6.11129 1.30288 6.17861 1.18465 6.29842C1.06642 6.41823 1 6.58073 1 6.75018V8.02794C1 8.19738 1.06642 8.35989 1.18465 8.4797C1.30288 8.59951 1.46323 8.66682 1.63043 8.66682L5.41304 8.66683ZM25.587 8.66683L27.4783 6.11129H29.3696C29.5358 6.11457 29.6942 6.18293 29.8118 6.30204C29.9293 6.42115 29.9968 6.58176 30 6.75018V8.02794C29.9968 8.19636 29.9293 8.35697 29.8118 8.47608C29.6942 8.59519 29.5358 8.66355 29.3696 8.66682L25.587 8.66683ZM29.8361 12.5001H24.3261M24.3261 12.5001L23.6957 15.0556M24.3261 12.5001H6.67391M23.6957 15.0556H27.4783C27.9939 15.0591 28.5007 14.9206 28.9448 14.6551C29.3889 14.3896 29.7536 14.0069 30 13.5479M23.6957 15.0556L21.1109 16.0906C20.7081 16.2468 20.2812 16.329 19.85 16.3334H10.4565C10.022 16.3257 9.59329 16.2301 9.19565 16.0523L7.30435 15.0556M1.16391 12.5001H6.67391M6.67391 12.5001L7.30435 15.0556M7.30435 15.0556H3.52174C3.00667 15.0563 2.50088 14.9167 2.05726 14.6515C1.61365 14.3862 1.2485 14.0051 1 13.5479M6.67391 21.4445L7.93478 18.8889M7.93478 18.8889H23.0652M7.93478 18.8889H3.52174M23.0652 18.8889L24.3261 21.4445M23.0652 18.8889H27.4783"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 31 25',
});

export const OvenIcon = createIcon({
  displayName: 'PowerPointIcon',
  path: (
    <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.2998" y="4.70752" width="16.401" height="10.6238" rx="0.75" stroke="currentColor" strokeWidth="0.5" />
      <rect x="4.4834" y="1" width="12.0312" height="3.45741" fill="currentColor" />
      <rect x="3.33887" y="5.66016" width="14.4661" height="0.601289" rx="0.300644" fill="currentColor" />
      <rect x="3.48887" y="7.0123" width="14.1661" height="7.06579" rx="0.85" stroke="currentColor" strokeWidth="0.3" />
      <g filter="url(#filter0_d)">
        <ellipse cx="14.2233" cy="2.80372" rx="1.0026" ry="1.05226" fill="white" />
      </g>
      <g filter="url(#filter1_d)">
        <ellipse cx="6.63249" cy="2.80372" rx="1.0026" ry="1.05226" fill="white" />
      </g>
      <path d="M6.63281 8.06543L9.9987 11.598" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.0703 9.41797L10.9297 10.3199" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.7891 11.3726L13.5078 13.1764" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6 16.5H19C19.5523 16.5 20 16.0523 20 15.5V2.5C20 1.94772 19.5523 1.5 19 1.5H2C1.44772 1.5 1 1.94772 1 2.5V15.5C1 16.0523 1.44772 16.5 2 16.5H4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d"
          x="11.2207"
          y="0.751465"
          width="6.00521"
          height="6.10451"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.607843 0 0 0 0 0.627451 0 0 0 0 0.631373 0 0 0 0.3 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter1_d"
          x="3.62988"
          y="0.751465"
          width="6.00521"
          height="6.10451"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.607843 0 0 0 0 0.627451 0 0 0 0 0.631373 0 0 0 0.3 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  ),
  viewBox: '0 0 21 17',
});

export const SolarPVIcon = createIcon({
  displayName: 'SolarPVIcon',
  path: (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1839 3.74006C11.1839 4.31544 10.7193 4.77697 10.147 4.77697H7.33476C6.75938 4.77697 6.29785 4.31236 6.29785 3.74006C6.29785 3.30007 6.57169 2.92161 6.95938 2.77085C6.93169 2.66623 6.91631 2.55546 6.91631 2.43854C6.91631 1.70009 7.51937 1.1001 8.25783 1.1001C8.99628 1.1001 9.59627 1.70009 9.59627 2.43854C9.59627 2.52777 9.59012 2.61392 9.57166 2.70008H10.147C10.7193 2.70315 11.1839 3.16469 11.1839 3.74006Z"
        fill="currentColor"
      />
      <path d="M8.74121 9.63854H11.2766L11.0366 7.87549H8.74121V9.63854Z" fill="currentColor" />
      <path d="M5.30176 11.7093H8.12634V10.2539H5.50176L5.30176 11.7093Z" fill="currentColor" />
      <path d="M8.74121 10.2539V11.7093H11.5627L11.3627 10.2539H8.74121Z" fill="currentColor" />
      <path d="M8.12632 7.87549H5.83096L5.58789 9.63854H8.12632V7.87549Z" fill="currentColor" />
      <path d="M8.74121 13.7831H11.8489L11.6489 12.3247H8.74121V13.7831Z" fill="currentColor" />
      <path
        d="M16.0521 14.3984H12.5537L12.7968 16.1615H15.8183C16.1814 16.1615 16.446 15.8169 16.3475 15.4661L16.0521 14.3984Z"
        fill="currentColor"
      />
      <path d="M4.59678 12.3247H1.38144L0.981445 13.7831H4.39679L4.59678 12.3247Z" fill="currentColor" />
      <path d="M4.88304 10.2539H1.95078L1.55078 11.7093H4.68305L4.88304 10.2539Z" fill="currentColor" />
      <path d="M8.12536 14.3984H4.93155L4.68848 16.1615H8.12536V14.3984Z" fill="currentColor" />
      <path
        d="M4.96609 9.63854L5.20916 7.87549H3.02457C2.77535 7.87549 2.55996 8.04164 2.49535 8.27856L2.12305 9.63854H4.96609Z"
        fill="currentColor"
      />
      <path
        d="M4.3105 14.3984H0.812079L0.519775 15.4661C0.424392 15.8169 0.685927 16.1615 1.049 16.1615H4.0705L4.3105 14.3984Z"
        fill="currentColor"
      />
      <path
        d="M11.8982 9.63854H14.7443L14.372 8.27856C14.3074 8.03856 14.0889 7.87549 13.8428 7.87549H11.6582L11.8982 9.63854Z"
        fill="currentColor"
      />
      <path d="M15.4819 12.3247H12.2666L12.4666 13.7831H15.8819L15.4819 12.3247Z" fill="currentColor" />
      <path d="M11.9319 14.3984H8.74121V16.1615H12.175L11.9319 14.3984Z" fill="currentColor" />
      <path d="M12.1844 11.7093H15.3136L14.9136 10.2539H11.9844L12.1844 11.7093Z" fill="currentColor" />
      <path d="M8.12523 13.7831V12.3247H5.21758L5.01758 13.7831H8.12523Z" fill="currentColor" />
      <path d="M9.25761 16.7769H7.6084V18.1584H9.25761V16.7769Z" fill="currentColor" />
      <path
        d="M11.7111 19.3247V20.0016H5.1543V19.3247C5.1543 19.0201 5.40045 18.7739 5.70506 18.7739H11.1604C11.465 18.7739 11.7111 19.0201 11.7111 19.3247Z"
        fill="currentColor"
      />
      <path
        d="M18.4772 3.74356C18.4772 4.69124 17.7049 5.46354 16.7542 5.46354C15.8065 5.46354 15.0342 4.69124 15.0342 3.74356C15.0342 2.79281 15.8065 2.02051 16.7542 2.02051C17.7049 2.02051 18.4772 2.79281 18.4772 3.74356Z"
        fill="currentColor"
      />
      <path
        d="M15.6591 1.40216C15.5391 1.40216 15.4253 1.33139 15.376 1.21447L15.0468 0.429863C14.9822 0.272942 15.056 0.0914056 15.213 0.0267911C15.3699 -0.0378235 15.5483 0.0360217 15.616 0.192943L15.9453 0.977548C16.0099 1.13447 15.936 1.316 15.7791 1.38062C15.7391 1.39293 15.6991 1.40216 15.6591 1.40216Z"
        fill="currentColor"
      />
      <path
        d="M14.1049 2.95572C14.0649 2.95572 14.0249 2.94648 13.9849 2.9311L13.2003 2.60187C13.0433 2.53726 12.9695 2.35572 13.0341 2.1988C13.0987 2.04188 13.2803 1.96804 13.4372 2.03265L14.2218 2.36188C14.3787 2.42649 14.4526 2.60803 14.3879 2.76495C14.3418 2.88495 14.2249 2.95572 14.1049 2.95572Z"
        fill="currentColor"
      />
      <path
        d="M13.3201 5.47266C13.2001 5.47266 13.0863 5.40189 13.037 5.28497C12.9724 5.12805 13.0463 4.94651 13.2032 4.8819L13.9878 4.55267C14.1447 4.48806 14.3232 4.5619 14.3909 4.71882C14.4555 4.87574 14.3816 5.05728 14.2247 5.12189L13.4401 5.45112C13.4001 5.4665 13.3601 5.47266 13.3201 5.47266Z"
        fill="currentColor"
      />
      <path
        d="M15.333 7.48189C15.293 7.48189 15.253 7.47266 15.213 7.45728C15.056 7.39266 14.9822 7.21113 15.0468 7.05421L15.376 6.2696C15.4407 6.11268 15.6222 6.03884 15.7791 6.10345C15.936 6.16807 16.0099 6.3496 15.9453 6.50652L15.616 7.29113C15.5668 7.41113 15.453 7.48189 15.333 7.48189Z"
        fill="currentColor"
      />
      <path
        d="M18.1786 7.48175C18.0586 7.48175 17.9448 7.41098 17.8956 7.29406L17.5663 6.50945C17.5017 6.35253 17.5756 6.171 17.7325 6.10638C17.8894 6.04177 18.0679 6.11561 18.1356 6.27253L18.4648 7.05714C18.5294 7.21406 18.4556 7.39559 18.2986 7.46021C18.2556 7.47559 18.2156 7.48175 18.1786 7.48175Z"
        fill="currentColor"
      />
      <path
        d="M20.1879 5.47281C20.1479 5.47281 20.1079 5.46357 20.0679 5.44819L19.2833 5.11896C19.1264 5.05435 19.0525 4.87281 19.1171 4.71589C19.1817 4.55897 19.3633 4.48513 19.5202 4.54974L20.3048 4.87897C20.4617 4.94358 20.5356 5.12512 20.471 5.28204C20.4217 5.40204 20.3079 5.47281 20.1879 5.47281Z"
        fill="currentColor"
      />
      <path
        d="M19.4031 2.95572C19.2831 2.95572 19.1693 2.88495 19.1201 2.76495C19.0554 2.60803 19.1293 2.42649 19.2862 2.36188L20.0739 2.03265C20.2308 1.96804 20.4093 2.04188 20.477 2.1988C20.5416 2.35572 20.4677 2.53726 20.3108 2.60187L19.5231 2.9311C19.4831 2.94648 19.4431 2.95572 19.4031 2.95572Z"
        fill="currentColor"
      />
      <path
        d="M17.8496 1.40182C17.8096 1.40182 17.7696 1.39259 17.7296 1.3772C17.5726 1.31259 17.4988 1.13105 17.5634 0.97413L17.8926 0.189525C17.9573 0.0326037 18.1388 -0.0412414 18.2957 0.0233731C18.4526 0.0879876 18.5265 0.269524 18.4619 0.426445L18.1326 1.21105C18.0834 1.33105 17.9696 1.40182 17.8496 1.40182Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 21 21',
});

export const GridConnectionIcon = createIcon({
  displayName: 'GridConnectionIcon',
  path: (
    <svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.54761 15.2857L3.11904 19.0952L8.35713 15.2857M4.54761 15.2857L9.7857 19.0952L8.35713 15.2857M4.54761 15.2857H8.35713M4.54761 15.2857V11.4762M4.54761 15.2857L8.11903 11.4762H4.54761M4.54761 3.61904L6.45237 1L8.35713 3.61904M4.54761 3.61904L8.11903 7.54761H4.54761M4.54761 3.61904H8.35713M4.54761 3.61904H0.5L4.54761 7.42856M4.54761 3.61904V7.42856M8.35713 3.61904L4.54761 7.54761M8.35713 3.61904H12.1666L8.35713 7.66665M8.35713 3.61904V7.66665M8.35713 15.2857L4.54761 11.4762M8.35713 15.2857V7.66665M4.54761 11.4762L8.11903 7.66665M4.54761 11.4762V7.54761M4.54761 7.54761L8.11903 11.2381M4.54761 7.54761V7.42856"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinejoin="round"
      />
      <path
        d="M2.18104 20.0357C2.21138 19.6493 2.53453 19.3452 2.92871 19.3452H9.97631C10.3705 19.3452 10.6936 19.6493 10.724 20.0357H2.18104Z"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <mask id="path-3-inside-1" fill="white">
        <path d="M0.5 20.524C0.5 20.261 0.713197 20.0479 0.976188 20.0479H11.9285C12.1915 20.0479 12.4047 20.261 12.4047 20.524C12.4047 20.787 12.1915 21.0002 11.9286 21.0002H0.976188C0.713197 21.0002 0.5 20.787 0.5 20.524Z" />
      </mask>
      <path
        d="M0.976188 21.0479H11.9285V19.0479H0.976188V21.0479ZM11.9286 20.0002H0.976188V22.0002H11.9286V20.0002ZM0.976188 20.0002C1.26548 20.0002 1.5 20.2347 1.5 20.524H-0.5C-0.5 21.3393 0.160913 22.0002 0.976188 22.0002V20.0002ZM11.4047 20.524C11.4047 20.2347 11.6393 20.0002 11.9286 20.0002V22.0002C12.7438 22.0002 13.4047 21.3393 13.4047 20.524H11.4047ZM11.9285 21.0479C11.6393 21.0479 11.4047 20.8133 11.4047 20.524H13.4047C13.4047 19.7088 12.7438 19.0479 11.9285 19.0479V21.0479ZM0.976188 19.0479C0.160911 19.0479 -0.5 19.7088 -0.5 20.524H1.5C1.5 20.8133 1.26548 21.0479 0.976188 21.0479V19.0479Z"
        fill="currentColor"
        mask="url(#path-3-inside-1)"
      />
    </svg>
  ),
  viewBox: '0 0 13 21',
});

export const BatteryIcon = createIcon({
  displayName: 'BatteryIcon',
  path: (
    <svg width="21" height="11" viewBox="0 0 21 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.83334 8.09588V2.57085C1.83378 2.24278 1.9643 1.92827 2.19628 1.69628C2.42827 1.4643 2.74277 1.33378 3.07085 1.33334H8.79754L9.81421 0H3.07085C2.38925 0.00077197 1.7358 0.271876 1.25384 0.753837C0.771876 1.2358 0.500772 1.88925 0.5 2.57085V8.09588C0.500772 8.77747 0.771876 9.43093 1.25384 9.91289C1.7358 10.3948 2.38925 10.666 3.07085 10.6667H7.10628C7.09326 10.5651 7.09692 10.4621 7.11712 10.3617L7.12337 10.3305L7.13212 10.3001L7.40295 9.33338H3.07085C2.74277 9.33294 2.42827 9.20242 2.19628 8.97044C1.9643 8.73846 1.83378 8.42395 1.83334 8.09588Z"
        fill="currentColor"
      />
      <path
        d="M15.9291 0H11.8191C11.8314 0.0999615 11.8276 0.201238 11.8079 0.300002L11.8016 0.330835L11.7929 0.361252L11.5204 1.33334H15.9291C16.2572 1.33378 16.5717 1.4643 16.8037 1.69628C17.0357 1.92827 17.1662 2.24278 17.1666 2.57085V8.09588C17.1662 8.42395 17.0357 8.73846 16.8037 8.97044C16.5717 9.20242 16.2572 9.33294 15.9291 9.33338H10.1249L9.10742 10.6667H15.9291C16.6107 10.666 17.2642 10.3948 17.7461 9.91289C18.2281 9.43093 18.4992 8.77747 18.5 8.09588V2.57085C18.4992 1.88925 18.2281 1.2358 17.7461 0.753837C17.2642 0.271876 16.6107 0.00077197 15.9291 0Z"
        fill="currentColor"
      />
      <path
        d="M6.61066 6.92271C6.4258 6.92274 6.24443 6.87232 6.08613 6.77686C5.92782 6.68141 5.79857 6.54454 5.71232 6.38104C5.6231 6.2133 5.58145 6.02436 5.59188 5.83466C5.6023 5.64496 5.66442 5.46172 5.77149 5.30478L5.7844 5.28561L5.79815 5.26728L8.06775 2.29102H3.57064C3.34963 2.29102 3.13766 2.37881 2.98138 2.53509C2.8251 2.69138 2.7373 2.90334 2.7373 3.12435V7.54104C2.7373 7.76206 2.8251 7.97402 2.98138 8.1303C3.13766 8.28658 3.34963 8.37438 3.57064 8.37438H7.6715L8.079 6.92187L6.61066 6.92271Z"
        fill="currentColor"
      />
      <path
        d="M11.3361 6.36973L12.464 4.89097C12.4799 4.86684 12.4908 4.83979 12.4961 4.81138C12.4978 4.8023 12.4989 4.79311 12.4994 4.78388C12.5006 4.7659 12.4995 4.74783 12.4961 4.73013C12.4912 4.70429 12.4816 4.67956 12.4678 4.65722C12.4587 4.64267 12.4478 4.62937 12.4353 4.61763C12.4291 4.61178 12.4224 4.60648 12.4153 4.6018C12.4011 4.5918 12.3855 4.58407 12.369 4.57888C12.3514 4.57329 12.3329 4.57048 12.3144 4.57055H9.74691L10.2519 2.77012L10.3865 2.29095L10.6452 1.36761L10.6665 1.29095L10.9911 0.134275C10.9924 0.126703 10.9931 0.11904 10.9932 0.111359C10.9932 0.108858 10.9932 0.106775 10.9932 0.104692C10.9932 0.102608 10.9932 0.0938581 10.9911 0.088858C10.989 0.083858 10.9911 0.085108 10.9911 0.0830247C10.9894 0.0765345 10.987 0.0702471 10.984 0.0642747C10.9807 0.0586386 10.9771 0.0532114 10.9732 0.0480247L10.9694 0.0438584C10.9661 0.0404507 10.9627 0.0372496 10.959 0.0342745L10.9548 0.0309411C10.9497 0.0272167 10.9442 0.0238748 10.9386 0.0209414C10.9331 0.0183841 10.9274 0.0164282 10.9215 0.0151081H10.9161H10.9023H10.8969C10.8907 0.0144952 10.8844 0.0144952 10.8782 0.0151081C10.8721 0.0164972 10.8662 0.0185948 10.8607 0.0213579L10.8552 0.0242749L10.8428 0.0330246L10.8382 0.0371915C10.8325 0.0422973 10.8275 0.0480289 10.8232 0.0542751L10.0732 1.03886L9.52566 1.75637L9.11524 2.29095L6.46064 5.77222C6.45365 5.78283 6.44752 5.79397 6.44231 5.80556C6.43565 5.82006 6.43075 5.8353 6.42773 5.85097C6.42415 5.86865 6.42302 5.88674 6.42439 5.90472C6.42579 5.93509 6.434 5.96476 6.44843 5.99152C6.46286 6.01828 6.48312 6.04145 6.50773 6.05931C6.51494 6.0641 6.52245 6.06842 6.53023 6.07222C6.55478 6.0841 6.58171 6.09022 6.60898 6.09014H9.17649L7.93398 10.5243C7.93339 10.5321 7.93339 10.5399 7.93398 10.5477C7.93398 10.5477 7.93398 10.5518 7.93398 10.5539C7.93438 10.5593 7.93521 10.5645 7.93648 10.5697C7.93625 10.5717 7.93625 10.5736 7.93648 10.5756C7.93815 10.5821 7.94053 10.5884 7.94357 10.5943C7.94684 10.5998 7.95046 10.6051 7.9544 10.6102L7.95815 10.6143L7.96857 10.6243C7.97013 10.6252 7.97154 10.6263 7.97273 10.6277C7.97781 10.6314 7.98326 10.6346 7.98898 10.6372C7.99452 10.6396 8.00023 10.6416 8.00607 10.6431H8.01148C8.01606 10.6435 8.02066 10.6435 8.02523 10.6431H8.03065C8.03697 10.6429 8.04325 10.642 8.0494 10.6406C8.05532 10.639 8.06105 10.6367 8.06649 10.6339L8.0719 10.631L8.0844 10.6222L8.08899 10.6185C8.09462 10.6134 8.09965 10.6077 8.10399 10.6014L9.07566 9.33266L9.80608 8.37432L11.3361 6.36973Z"
        fill="currentColor"
      />
      <path
        d="M19.8337 3.11084C19.6569 3.11084 19.4873 3.18108 19.3623 3.3061C19.2372 3.43113 19.167 3.6007 19.167 3.77751V6.88836C19.167 7.06517 19.2372 7.23474 19.3623 7.35977C19.4873 7.48479 19.6569 7.55503 19.8337 7.55503C20.0105 7.55503 20.18 7.48479 20.3051 7.35977C20.4301 7.23474 20.5003 7.06517 20.5003 6.88836V3.77751C20.5003 3.6007 20.4301 3.43113 20.3051 3.3061C20.18 3.18108 20.0105 3.11084 19.8337 3.11084Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 21 11',
});

export const SolarBatteryHybridIcon = createIcon({
  displayName: 'SolarBatteryHybridIcon',
  path: (
    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.4588 14.4227L18.3116 14.4227C18.1841 14.4226 18.0619 14.3718 17.9717 14.2817C17.8816 14.1915 17.8309 14.0693 17.8307 13.9418L17.8307 11.7162L17.3125 11.3211L17.3125 13.9418C17.3128 14.2067 17.4182 14.4606 17.6055 14.648C17.7928 14.8353 18.0467 14.9406 18.3116 14.9409L20.4588 14.9409C20.7237 14.9406 20.9777 14.8353 21.165 14.648C21.3523 14.4606 21.4577 14.2067 21.458 13.9418L21.458 12.3735C21.4185 12.3785 21.3784 12.3771 21.3394 12.3693L21.3273 12.3669L21.3155 12.3634L20.9398 12.2582L20.9398 13.9418C20.9396 14.0693 20.8889 14.1915 20.7987 14.2817C20.7086 14.3718 20.5863 14.4226 20.4588 14.4227Z"
        fill="currentColor"
      />
      <path
        d="M17.3125 8.94456L17.3125 10.5419C17.3513 10.5371 17.3907 10.5386 17.4291 10.5462L17.4411 10.5487L17.4529 10.5521L17.8307 10.658L17.8307 8.94456C17.8309 8.81706 17.8816 8.69483 17.9717 8.60467C18.0619 8.51452 18.1841 8.46379 18.3116 8.46362L20.4588 8.46362C20.5863 8.46379 20.7086 8.51452 20.7987 8.60467C20.8889 8.69483 20.9396 8.81706 20.9398 8.94456L20.9398 11.2003L21.458 11.5957L21.458 8.94456C21.4577 8.67967 21.3523 8.42571 21.165 8.2384C20.9777 8.0511 20.7237 7.94574 20.4588 7.94544L18.3116 7.94544C18.0467 7.94574 17.7928 8.0511 17.6055 8.2384C17.4182 8.42571 17.3128 8.67967 17.3125 8.94456Z"
        fill="currentColor"
      />
      <path
        d="M20.0032 12.5665C20.0032 12.6383 19.9836 12.7088 19.9465 12.7703C19.9094 12.8318 19.8562 12.8821 19.7926 12.9156C19.7275 12.9503 19.654 12.9664 19.5803 12.9624C19.5066 12.9583 19.4354 12.9342 19.3744 12.8926L19.3669 12.8876L19.3598 12.8822L18.2031 12.0002L18.2031 13.7479C18.2031 13.8338 18.2372 13.9162 18.298 13.9769C18.3587 14.0377 18.4411 14.0718 18.527 14.0718L20.2435 14.0718C20.3294 14.0718 20.4117 14.0377 20.4725 13.9769C20.5332 13.9162 20.5673 13.8338 20.5673 13.7479L20.5673 12.1542L20.0028 11.9958L20.0032 12.5665Z"
        fill="currentColor"
      />
      <path
        d="M19.7882 10.7296L19.2135 10.2913C19.2041 10.2851 19.1936 10.2808 19.1825 10.2788C19.179 10.2781 19.1754 10.2777 19.1718 10.2775C19.1649 10.277 19.1578 10.2774 19.151 10.2788C19.1409 10.2807 19.1313 10.2844 19.1226 10.2898C19.117 10.2933 19.1118 10.2976 19.1072 10.3024C19.105 10.3048 19.1029 10.3074 19.1011 10.3102C19.0972 10.3157 19.0942 10.3218 19.0922 10.3282C19.09 10.335 19.0889 10.3422 19.0889 10.3494L19.0889 11.3472L18.3892 11.1509L18.203 11.0986L17.8442 10.9981L17.8144 10.9898L17.3649 10.8637C17.3619 10.8632 17.3589 10.8629 17.3559 10.8629C17.355 10.8629 17.3542 10.8629 17.3534 10.8629C17.3525 10.8629 17.3491 10.8629 17.3472 10.8637C17.3453 10.8645 17.3457 10.8637 17.3449 10.8637C17.3424 10.8643 17.34 10.8653 17.3376 10.8664C17.3355 10.8677 17.3333 10.8691 17.3313 10.8706L17.3297 10.8721C17.3284 10.8734 17.3271 10.8747 17.326 10.8761L17.3247 10.8778C17.3232 10.8798 17.3219 10.8819 17.3208 10.8841C17.3198 10.8862 17.3191 10.8884 17.3185 10.8907L17.3185 10.8928L17.3185 10.8982L17.3185 10.9003C17.3183 10.9027 17.3183 10.9051 17.3185 10.9076C17.3191 10.9099 17.3199 10.9122 17.321 10.9144L17.3221 10.9165L17.3255 10.9213L17.3271 10.9231C17.3291 10.9253 17.3313 10.9273 17.3338 10.9289L17.7164 11.2204L17.9953 11.4332L18.203 11.5927L19.5559 12.6244C19.5601 12.6271 19.5644 12.6295 19.5689 12.6315C19.5745 12.6341 19.5805 12.636 19.5866 12.6372C19.5934 12.6385 19.6005 12.639 19.6074 12.6385C19.6192 12.6379 19.6308 12.6347 19.6412 12.6291C19.6516 12.6235 19.6606 12.6156 19.6675 12.6061C19.6694 12.6033 19.6711 12.6003 19.6725 12.5973C19.6772 12.5878 19.6795 12.5773 19.6795 12.5667L19.6795 11.5689L21.4028 12.0518C21.4058 12.052 21.4088 12.052 21.4118 12.0518C21.4118 12.0518 21.4135 12.0518 21.4143 12.0518C21.4164 12.0516 21.4184 12.0513 21.4204 12.0508C21.4212 12.0509 21.4219 12.0509 21.4227 12.0508C21.4252 12.0502 21.4277 12.0492 21.43 12.048C21.4321 12.0468 21.4342 12.0454 21.4361 12.0438L21.4378 12.0424L21.4416 12.0383C21.442 12.0377 21.4424 12.0372 21.4429 12.0367C21.4444 12.0347 21.4456 12.0326 21.4467 12.0304C21.4476 12.0282 21.4483 12.026 21.4489 12.0238L21.4489 12.0217C21.4491 12.0199 21.4491 12.0181 21.4489 12.0163L21.4489 12.0142C21.4488 12.0117 21.4485 12.0093 21.448 12.0069C21.4473 12.0046 21.4465 12.0024 21.4454 12.0003L21.4442 11.9982L21.4408 11.9933L21.4394 11.9915C21.4374 11.9893 21.4352 11.9874 21.4327 11.9857L20.9397 11.6081L20.5672 11.3242L19.7882 10.7296Z"
        fill="currentColor"
      />
      <path
        d="M18.5215 7.42743C18.5215 7.49615 18.5488 7.56205 18.5974 7.61064C18.646 7.65923 18.7119 7.68652 18.7806 7.68652L19.9896 7.68652C20.0583 7.68652 20.1242 7.65923 20.1728 7.61064C20.2214 7.56205 20.2486 7.49615 20.2486 7.42743C20.2486 7.35872 20.2214 7.29282 20.1728 7.24423C20.1242 7.19564 20.0583 7.16834 19.9896 7.16834L18.7806 7.16834C18.7119 7.16834 18.646 7.19564 18.5974 7.24423C18.5488 7.29282 18.5215 7.35872 18.5215 7.42743Z"
        fill="currentColor"
      />
      <path d="M8.95996 2.14463H11.5625L11.3162 0H8.95996V2.14463Z" fill="currentColor" />
      <path d="M5.42871 4.66342H8.32816V2.89307H5.63401L5.42871 4.66342Z" fill="currentColor" />
      <path d="M8.95996 2.89307V4.66342H11.8563L11.651 2.89307H8.95996Z" fill="currentColor" />
      <path d="M8.32837 0H5.97217L5.72266 2.14463H8.32837V0Z" fill="currentColor" />
      <path d="M8.95996 7.1862H12.15L11.9447 5.41211H8.95996V7.1862Z" fill="currentColor" />
      <path
        d="M16.4642 7.93457H12.873L13.1226 10.0792H16.2242C16.5969 10.0792 16.8685 9.66001 16.7674 9.23333L16.4642 7.93457Z"
        fill="currentColor"
      />
      <path d="M4.70531 5.41211H1.40474L0.994141 7.1862H4.50001L4.70531 5.41211Z" fill="currentColor" />
      <path d="M4.99872 2.89307H1.98872L1.57812 4.66342H4.79342L4.99872 2.89307Z" fill="currentColor" />
      <path d="M8.32778 7.93457H5.04932L4.7998 10.0792H8.32778V7.93457Z" fill="currentColor" />
      <path
        d="M5.08442 2.14463L5.33393 0H3.09144C2.83561 0 2.61451 0.202112 2.54819 0.490309L2.16602 2.14463H5.08442Z"
        fill="currentColor"
      />
      <path
        d="M4.4115 7.93457H0.820352L0.5203 9.23333C0.422388 9.66001 0.690856 10.0792 1.06355 10.0792H4.16514L4.4115 7.93457Z"
        fill="currentColor"
      />
      <path
        d="M12.1995 2.14463H15.121L14.7389 0.490309C14.6725 0.198369 14.4483 0 14.1956 0H11.9531L12.1995 2.14463Z"
        fill="currentColor"
      />
      <path d="M15.8797 5.41211H12.5791L12.7844 7.1862H16.2903L15.8797 5.41211Z" fill="currentColor" />
      <path d="M12.2353 7.93457H8.95996V10.0792H12.4848L12.2353 7.93457Z" fill="currentColor" />
      <path d="M12.4944 4.66342H15.7065L15.2959 2.89307H12.2891L12.4944 4.66342Z" fill="currentColor" />
      <path d="M8.32772 7.1862V5.41211H5.34299L5.1377 7.1862H8.32772Z" fill="currentColor" />
      <path d="M9.4898 10.8281H7.79688V12.5087H9.4898V10.8281Z" fill="currentColor" />
      <path
        d="M12.008 13.9268V14.7502H5.27734V13.9268C5.27734 13.5563 5.53002 13.2568 5.84271 13.2568H11.4426C11.7553 13.2568 12.008 13.5563 12.008 13.9268Z"
        fill="currentColor"
      />
      <path
        d="M11.5547 14.2788H14.1558V11.5151H17.082"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 24 16',
});

export const CircuitPlaceholderIcon = createIcon({
  displayName: 'CircuitPlaceholderIcon',
  path: (
    <svg width="48px" height="48px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="9"
        y="9"
        width="30"
        height="30"
        rx="2"
        ry="2"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <rect
        x="18"
        y="18"
        width="12"
        height="12"
        rx="1"
        ry="1"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        x1="16"
        y1="47"
        x2="16"
        y2="39.19"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        x1="24"
        y1="47"
        x2="24"
        y2="39.19"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        x1="32"
        y1="47"
        x2="32"
        y2="39.19"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        x1="16"
        y1="9"
        x2="16"
        y2="1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        x1="24"
        y1="8.9"
        x2="24"
        y2="1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        x1="32"
        y1="9"
        x2="32"
        y2="1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        x1="47"
        y1="32"
        x2="39"
        y2="32"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        x1="47"
        y1="24"
        x2="39"
        y2="24"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        x1="47"
        y1="16"
        x2="39"
        y2="16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        x1="9"
        y1="32"
        x2="1"
        y2="32"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        x1="8.87"
        y1="24"
        x2="1"
        y2="24"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        x1="9"
        y1="16"
        x2="1"
        y2="16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <rect width="48" height="48" fill="none" />
    </svg>
  ),
  viewBox: '0 0 48 48',
});

export const BackupCircuitIcon = createIcon({
  displayName: 'BackupCircuitIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="19" viewBox="0 0 15 19" fill="none">
      <path
        d="M14.75 2.71429C14.75 1.21532 13.5537 0 12.0781 0C10.6026 0 9.40625 1.21532 9.40625 2.71429C9.40625 3.8147 10.4985 4.76018 11.425 5.18655C11.8714 7.125 8.575 8.55 7.625 9.025C6.675 9.5 4.78732 10.2227 3.825 10.925V5.18655C4.77441 4.7699 5.84375 3.83144 5.84375 2.71429C5.84375 1.21532 4.64742 0 3.17188 0C1.69633 0 0.5 1.21532 0.5 2.71429C0.5 3.83144 1.45059 4.80564 2.4 5.22229V13.8139C1.45059 14.2299 0.5 15.1686 0.5 16.2857C0.5 17.7847 1.69633 19 3.17188 19C4.64742 19 5.84375 17.7847 5.84375 16.2857C5.84375 15.1853 4.7517 14.2398 3.825 13.8139C4.07816 11.6108 8.575 9.975 8.575 9.975C8.575 9.975 12.375 8.55 12.85 5.225C13.8183 4.81718 14.75 3.84524 14.75 2.71429ZM1.63043 2.71429C1.63043 1.84979 2.32088 1.1486 3.17188 1.1486C4.02309 1.1486 4.71332 1.84979 4.71332 2.71429C4.71332 3.57924 4.02309 4.28043 3.17188 4.28043C2.32088 4.28043 1.63043 3.57924 1.63043 2.71429ZM3.17188 17.8519C2.32088 17.8519 1.63043 17.1507 1.63043 16.2857C1.63043 15.4212 2.32088 14.72 3.17188 14.72C4.02309 14.72 4.71332 15.4212 4.71332 16.2857C4.71332 17.1507 4.02309 17.8519 3.17188 17.8519ZM12.0781 4.28043C11.2271 4.28043 10.5367 3.57924 10.5367 2.71429C10.5367 1.84979 11.2271 1.1486 12.0781 1.1486C12.9293 1.1486 13.6196 1.84979 13.6196 2.71429C13.6196 3.57924 12.9293 4.28043 12.0781 4.28043Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 15 19',
});

export const CommonAreaIcon = createIcon({
  displayName: 'CommonAreaIcon',
  path: (
    <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.01515 4.2764H5.99806C5.73809 4.2764 5.52734 4.06566 5.52734 3.80568C5.52734 3.5457 5.73809 3.33496 5.99806 3.33496H6.01515C6.27513 3.33496 6.48587 3.5457 6.48587 3.80568C6.48587 4.06566 6.27508 4.2764 6.01515 4.2764Z"
        fill="currentColor"
      />
      <path
        d="M10.0044 4.2764H9.98732C9.72734 4.2764 9.5166 4.06566 9.5166 3.80568C9.5166 3.5457 9.72734 3.33496 9.98732 3.33496H10.0044C10.2643 3.33496 10.4751 3.5457 10.4751 3.80568C10.4751 4.06566 10.2643 4.2764 10.0044 4.2764Z"
        fill="currentColor"
      />
      <path
        d="M14.1089 4.2764H14.0918C13.8319 4.2764 13.6211 4.06566 13.6211 3.80568C13.6211 3.5457 13.8319 3.33496 14.0918 3.33496H14.1089C14.3688 3.33496 14.5796 3.5457 14.5796 3.80568C14.5796 4.06566 14.3688 4.2764 14.1089 4.2764Z"
        fill="currentColor"
      />
      <path
        d="M16.1048 7.61077H3.89478C3.63481 7.61077 3.42406 7.40003 3.42406 7.14005V4.01062C3.42406 3.93069 3.35906 3.86568 3.27913 3.86568H2.43263C2.17266 3.86568 1.96191 3.65494 1.96191 3.39497V1.08637C1.96191 0.487335 2.44925 0 3.04824 0H16.9513C17.5503 0 18.0376 0.487335 18.0376 1.08637V3.39492C18.0376 3.6549 17.8268 3.86564 17.5669 3.86564H16.7204C16.6405 3.86564 16.5755 3.93064 16.5755 4.01057V7.14C16.5755 7.39998 16.3648 7.61077 16.1048 7.61077ZM4.3655 6.66933H15.6341V4.01062C15.6341 3.41158 16.1215 2.92425 16.7205 2.92425H17.0962V1.08637C17.0962 1.00644 17.0312 0.941438 16.9513 0.941438H3.04824C2.96836 0.941438 2.90335 1.00644 2.90335 1.08637V2.9242H3.27908C3.87812 2.9242 4.36546 3.41153 4.36546 4.01057V6.66933H4.3655Z"
        fill="currentColor"
      />
      <path
        d="M18.4136 11.356H1.58633C0.987337 11.356 0.5 10.8687 0.5 10.2696V4.01069C0.5 3.41165 0.987337 2.92432 1.58633 2.92432H3.27932C3.87836 2.92432 4.36569 3.41165 4.36569 4.01069V6.66941H15.6343V4.01069C15.6343 3.41165 16.1217 2.92432 16.7207 2.92432H18.4137C19.0127 2.92432 19.5 3.41165 19.5 4.01069V10.2696C19.5 10.8687 19.0127 11.356 18.4136 11.356ZM1.58633 3.86576C1.50645 3.86576 1.44144 3.93076 1.44144 4.01069V10.2696C1.44144 10.3495 1.50645 10.4146 1.58633 10.4146H18.4136C18.4935 10.4146 18.5585 10.3495 18.5585 10.2696V4.01069C18.5585 3.93081 18.4935 3.86576 18.4136 3.86576H16.7206C16.6407 3.86576 16.5757 3.93076 16.5757 4.01069V7.14013C16.5757 7.40011 16.3649 7.61085 16.105 7.61085H3.89497C3.63499 7.61085 3.42425 7.40011 3.42425 7.14013V4.01069C3.42425 3.93081 3.35925 3.86576 3.27932 3.86576H1.58633Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 20 12',
});

export const FridgeIcon = createIcon({
  displayName: 'FridgeIcon',
  path: (
    <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.83252 0H1.95282C1.15169 0 0.5 0.651692 0.5 1.45282V16.8111C0.5 17.6123 1.15169 18.264 1.95282 18.264H8.83252C9.63364 18.264 10.2853 17.6123 10.2853 16.8111V1.45282C10.2853 0.651692 9.63364 0 8.83252 0ZM8.71343 17.6258H2.07199C1.49958 17.6258 1.09335 17.1855 1.09335 16.6135V6.33831H9.6561V16.6135C9.6561 17.1859 9.28584 17.6258 8.71343 17.6258ZM9.6561 5.61202H1.09335V1.58535C1.09335 1.01336 1.49958 0.540321 2.07199 0.540321H8.58609C9.1585 0.540321 9.6561 1.01336 9.6561 1.58535V5.61202Z"
        fill="currentColor"
      />
      <path
        d="M9.16914 1.99707C9.00294 1.99707 8.86914 2.09005 8.86914 2.20462V4.04886C8.86914 4.16343 9.00294 4.25641 9.16914 4.25641C9.33414 4.25641 9.46914 4.16343 9.46914 4.04886V2.20462C9.46914 2.09005 9.33414 1.99707 9.16914 1.99707Z"
        fill="currentColor"
      />
      <path
        d="M9.16914 7.68164C9.00294 7.68164 8.86914 7.77462 8.86914 7.88919V9.73385C8.86914 9.84841 9.00294 9.94139 9.16914 9.94139C9.33414 9.94139 9.46914 9.84841 9.46914 9.73385V7.88919C9.46914 7.77462 9.33414 7.68164 9.16914 7.68164Z"
        fill="currentColor"
      />
      <path
        d="M2.4055 19.0001C2.51965 19.0001 2.61305 18.9075 2.61305 18.7925C2.61305 18.6784 2.51965 18.585 2.4055 18.585H1.73098C1.616 18.585 1.52344 18.6784 1.52344 18.7925C1.52344 18.9075 1.616 19.0001 1.73098 19.0001H2.4055Z"
        fill="currentColor"
      />
      <path
        d="M9.05492 19.0001C9.1699 19.0001 9.26246 18.9075 9.26246 18.7925C9.26246 18.6784 9.1699 18.585 9.05492 18.585H8.3804C8.26625 18.585 8.17285 18.6784 8.17285 18.7925C8.17285 18.9075 8.26625 19.0001 8.3804 19.0001H9.05492Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 11 19',
});

export const GarageIcon = createIcon({
  displayName: 'GarageIcon',
  path: (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1724 14.7394H18.5172V5.23941C18.5172 5.23941 18.5172 5.2132 18.5172 5.20337C18.5191 5.18157 18.5191 5.15965 18.5172 5.13785C18.5105 5.11738 18.5017 5.09763 18.491 5.07889L18.455 5.02975C18.4411 5.01203 18.4245 4.99656 18.4059 4.98389C18.4059 4.98389 18.3895 4.96423 18.3764 4.95768L10.1867 0.0438884C10.1369 0.0151367 10.0804 0 10.0229 0C9.96543 0 9.90894 0.0151367 9.85914 0.0438884L1.66948 4.95768C1.66948 4.95768 1.64983 4.97734 1.64 4.98389C1.62136 4.99656 1.60479 5.01203 1.59086 5.02975C1.57702 5.04589 1.56494 5.06346 1.55483 5.08216C1.54352 5.0994 1.5347 5.11815 1.52862 5.13785C1.52677 5.15965 1.52677 5.18157 1.52862 5.20337L1.48276 5.23941V14.7394H0.827586C0.740705 14.7394 0.657382 14.7739 0.595948 14.8354C0.534513 14.8968 0.5 14.9801 0.5 15.067C0.5 15.1539 0.534513 15.2372 0.595948 15.2986C0.657382 15.3601 0.740705 15.3946 0.827586 15.3946H19.1724C19.2593 15.3946 19.3426 15.3601 19.4041 15.2986C19.4655 15.2372 19.5 15.1539 19.5 15.067C19.5 14.9801 19.4655 14.8968 19.4041 14.8354C19.3426 14.7739 19.2593 14.7394 19.1724 14.7394ZM4.43103 14.7394V7.53251H15.569V14.7394H4.43103ZM16.2241 14.7394V7.20492C16.2241 7.11804 16.1896 7.03472 16.1282 6.97328C16.0668 6.91185 15.9834 6.87734 15.8966 6.87734H4.10345C4.01657 6.87734 3.93324 6.91185 3.87181 6.97328C3.81038 7.03472 3.77586 7.11804 3.77586 7.20492V14.7394H2.5V5.5L9.85914 1L17.5 5.5V14.7394H16.2241Z"
        fill="currentColor"
      />
      <path
        d="M10.9826 5.56689H9.01704C8.93016 5.56689 8.84683 5.60141 8.7854 5.66284C8.72397 5.72428 8.68945 5.8076 8.68945 5.89448C8.68945 5.98136 8.72397 6.06469 8.7854 6.12612C8.84683 6.18755 8.93016 6.22207 9.01704 6.22207H10.9826C11.0694 6.22207 11.1528 6.18755 11.2142 6.12612C11.2756 6.06469 11.3101 5.98136 11.3101 5.89448C11.3101 5.8076 11.2756 5.72428 11.2142 5.66284C11.1528 5.60141 11.0694 5.56689 10.9826 5.56689Z"
        fill="currentColor"
      />
      <path
        d="M12.9487 8.84277H7.0522C6.96531 8.84277 6.88199 8.87729 6.82056 8.93872C6.75912 9.00016 6.72461 9.08348 6.72461 9.17036C6.72461 9.25724 6.75912 9.34056 6.82056 9.402C6.88199 9.46343 6.96531 9.49795 7.0522 9.49795H12.9487C13.0356 9.49795 13.119 9.46343 13.1804 9.402C13.2418 9.34056 13.2763 9.25724 13.2763 9.17036C13.2763 9.08348 13.2418 9.00016 13.1804 8.93872C13.119 8.87729 13.0356 8.84277 12.9487 8.84277Z"
        fill="currentColor"
      />
      <path
        d="M12.9487 10.8081H7.0522C6.96531 10.8081 6.88199 10.8426 6.82056 10.9041C6.75912 10.9655 6.72461 11.0488 6.72461 11.1357C6.72461 11.2226 6.75912 11.3059 6.82056 11.3673C6.88199 11.4288 6.96531 11.4633 7.0522 11.4633H12.9487C13.0356 11.4633 13.119 11.4288 13.1804 11.3673C13.2418 11.3059 13.2763 11.2226 13.2763 11.1357C13.2763 11.0488 13.2418 10.9655 13.1804 10.9041C13.119 10.8426 13.0356 10.8081 12.9487 10.8081Z"
        fill="currentColor"
      />
      <path
        d="M12.9487 12.7739H7.0522C6.96531 12.7739 6.88199 12.8084 6.82056 12.8699C6.75912 12.9313 6.72461 13.0146 6.72461 13.1015C6.72461 13.1884 6.75912 13.2717 6.82056 13.3332C6.88199 13.3946 6.96531 13.4291 7.0522 13.4291H12.9487C13.0356 13.4291 13.119 13.3946 13.1804 13.3332C13.2418 13.2717 13.2763 13.1884 13.2763 13.1015C13.2763 13.0146 13.2418 12.9313 13.1804 12.8699C13.119 12.8084 13.0356 12.7739 12.9487 12.7739Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 20 16',
});

export const KitchenIcon = createIcon({
  displayName: 'KitchenIcon',
  path: (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.8743 15.8627H8.12823C6.78794 15.8551 5.49831 15.3497 4.50963 14.4448C3.52094 13.5398 2.90373 12.2998 2.77779 10.9655C2.76317 10.8046 2.75586 10.6457 2.75586 10.4922V4.5H17.2229L17.2448 10.4922C17.2448 10.6457 17.2448 10.8046 17.2229 10.9655C17.0978 12.2998 16.4811 13.54 15.4926 14.4451C14.5041 15.3502 13.2145 15.8554 11.8743 15.8627ZM3.30406 5.40852V10.4922C3.30406 10.6292 3.30406 10.7718 3.32416 10.9179C3.43701 12.1161 3.99114 13.2295 4.87893 14.042C5.76672 14.8545 6.92479 15.308 8.12823 15.3145H11.8743C13.0785 15.3074 14.2371 14.8527 15.1247 14.0387C16.0123 13.2248 16.5654 12.1098 16.6765 10.9106C16.6893 10.7644 16.6966 10.6219 16.6966 10.4849V5.40852H3.30406Z"
        fill="currentColor"
      />
      <path
        d="M3.35666 11.2156H3.02957C2.35258 11.1977 1.70935 10.9161 1.23687 10.4309C0.764394 9.94576 0.5 9.29529 0.5 8.61807C0.5 7.94084 0.764394 7.29037 1.23687 6.80519C1.70935 6.32001 2.35258 6.03847 3.02957 6.02051H3.30367V10.492C3.30367 10.6291 3.30367 10.7716 3.32377 10.9178L3.35666 11.2156ZM2.75547 6.58698C2.26482 6.65458 1.81522 6.89751 1.48977 7.27087C1.16433 7.64423 1.13934 8.12278 1.13934 8.61807C1.13934 9.11336 1.16433 9.59191 1.48977 9.96526C1.81522 10.3386 2.26482 10.5816 2.75547 10.6492C2.75547 10.5962 2.75547 10.5432 2.75547 10.492V6.58698Z"
        fill="currentColor"
      />
      <path
        d="M16.9702 11.2156H16.6504L16.676 10.9105C16.6888 10.7643 16.6961 10.6217 16.6961 10.4847V6.02051H16.9702C17.6472 6.03847 18.2904 6.32001 18.7629 6.80519C19.2354 7.29037 19.4997 7.94084 19.4997 8.61807C19.4997 9.29529 19.2354 9.94576 18.7629 10.4309C18.2904 10.9161 17.6472 11.1977 16.9702 11.2156ZM17.2443 6.58698V10.492C17.2443 10.5432 17.2443 10.5962 17.2443 10.6492C17.7349 10.5816 18.1845 10.3386 18.51 9.96526C18.8354 9.59191 18.7629 9.11336 18.7629 8.61807C18.7629 8.12278 18.8354 7.64423 18.51 7.27087C18.1845 6.89751 17.7349 6.65458 17.2443 6.58698Z"
        fill="currentColor"
      />
      <path
        d="M16.875 3.30598V4.66583L3.125 4.66583V4.08084V3.38577C5.0081 2.74118 7.49678 2.39478 10.0028 2.37582C12.5093 2.35686 14.9953 2.66574 16.875 3.30598Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.75"
      />
      <path
        d="M11.161 1.76161C11.0883 1.76161 11.0186 1.73273 10.9672 1.68133C10.9158 1.62992 10.8869 1.5602 10.8869 1.48751C10.8924 1.36762 10.8735 1.24786 10.8313 1.13549C10.7892 1.02311 10.7247 0.920434 10.6418 0.833667C10.5589 0.7469 10.4593 0.67784 10.3489 0.630658C10.2385 0.583475 10.1198 0.559149 9.99976 0.559149C9.87975 0.559149 9.76098 0.583475 9.65062 0.630658C9.54027 0.67784 9.44063 0.7469 9.35771 0.833667C9.27479 0.920434 9.21032 1.02311 9.16819 1.13549C9.12606 1.24786 9.10715 1.36762 9.11259 1.48751C9.11259 1.5602 9.08371 1.62992 9.03231 1.68133C8.98091 1.73273 8.91119 1.76161 8.83849 1.76161C8.76579 1.76161 8.69608 1.73273 8.64467 1.68133C8.59327 1.62992 8.56439 1.5602 8.56439 1.48751C8.55751 1.2947 8.58954 1.10249 8.65858 0.922335C8.72762 0.742182 8.83224 0.577784 8.9662 0.438953C9.10017 0.300121 9.26073 0.189702 9.43831 0.114285C9.61588 0.0388683 9.80683 0 9.99976 0C10.1927 0 10.3836 0.0388683 10.5612 0.114285C10.7388 0.189702 10.8994 0.300121 11.0333 0.438953C11.1673 0.577784 11.2719 0.742182 11.3409 0.922335C11.41 1.10249 11.442 1.2947 11.4351 1.48751C11.4351 1.5602 11.4063 1.62992 11.3549 1.68133C11.3034 1.73273 11.2337 1.76161 11.161 1.76161Z"
        fill="currentColor"
      />
      <path
        d="M14.6481 12.3727C14.5754 12.3727 14.5057 12.3439 14.4543 12.2925C14.4029 12.2411 14.374 12.1713 14.374 12.0986V7.45721C14.374 7.38451 14.4029 7.31479 14.4543 7.26339C14.5057 7.21198 14.5754 7.18311 14.6481 7.18311C14.7208 7.18311 14.7905 7.21198 14.8419 7.26339C14.8933 7.31479 14.9222 7.38451 14.9222 7.45721V12.1041C14.9208 12.1759 14.8913 12.2442 14.84 12.2944C14.7888 12.3446 14.7199 12.3728 14.6481 12.3727Z"
        fill="currentColor"
      />
      <path
        d="M13.486 12.3727C13.4133 12.3727 13.3436 12.3438 13.2922 12.2924C13.2408 12.241 13.2119 12.1713 13.2119 12.0986V8.61932C13.2119 8.54662 13.2408 8.4769 13.2922 8.4255C13.3436 8.37409 13.4133 8.34521 13.486 8.34521C13.5587 8.34521 13.6284 8.37409 13.6798 8.4255C13.7312 8.4769 13.7601 8.54662 13.7601 8.61932V12.104C13.7587 12.1758 13.7292 12.2441 13.6779 12.2943C13.6267 12.3446 13.5578 12.3727 13.486 12.3727Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 20 16',
});

export const LaundryIcon = createIcon({
  displayName: 'LaundryIcon',
  path: (
    <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5 1L17.6731 14.3731C17.6 15.1038 16.9423 15.6154 16.2115 15.6154H3.78846C3.05769 15.6154 2.47308 15.1038 2.32692 14.3731L0.5 1"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 7.35185C17.8405 6.83333 16.8147 6.90741 16.2284 7.5C15.569 8.16667 14.3966 8.16667 13.7371 7.5C13.0776 6.83333 11.9052 6.83333 11.2457 7.5C10.5862 8.16667 9.41379 8.16667 8.75431 7.5C8.09483 6.83333 6.92241 6.83333 6.26293 7.5C5.60345 8.16667 4.43103 8.16667 3.77155 7.5C3.11207 6.90741 2.15948 6.83333 1.5 7.35185"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.20508 17.5449H12.923V17.0449H2.20508V17.5449ZM14.8717 17.5449H17.3076V17.0449H14.8717V17.5449Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 20 18',
});

export const MachineIcon = createIcon({
  displayName: 'MachineIcon',
  path: (
    <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.0449 0H1.17288C0.801805 0 0.5 0.301576 0.5 0.672328V4.57166V4.9015V18.3271C0.5 18.6982 0.801851 19 1.17288 19H15.0449C15.4156 19 15.7172 18.6981 15.7172 18.3271V4.90145V4.57161V0.672328C15.7172 0.301576 15.4156 0 15.0449 0ZM15.3874 18.3271C15.3874 18.5163 15.2338 18.6702 15.0449 18.6702H1.17288C0.983722 18.6702 0.829796 18.5163 0.829796 18.3271V17.8467H15.3874V18.3271ZM15.3874 17.3159H0.829796V5.16644H15.3874V17.3159ZM15.3874 4.57161H0.829796V0.672328C0.829796 0.483494 0.983676 0.329842 1.17288 0.329842H15.0449C15.2337 0.329842 15.3874 0.483494 15.3874 0.672328V4.57161Z"
        fill="currentColor"
      />
      <path
        d="M8.10933 16.3363C10.9918 16.3363 13.3368 13.9913 13.3368 11.1088C13.3368 8.22634 10.9918 5.88135 8.10933 5.88135C5.22688 5.88135 2.88184 8.22634 2.88184 11.1088C2.88184 13.9913 5.22688 16.3363 8.10933 16.3363ZM8.10933 6.37001C10.8099 6.37001 12.7398 8.40821 12.7398 11.1088C12.7398 13.8093 10.8099 15.7585 8.10933 15.7585C5.40875 15.7585 3.50024 13.8093 3.50024 11.1088C3.50024 8.40821 5.40875 6.37001 8.10933 6.37001Z"
        fill="currentColor"
      />
      <path
        d="M8.10898 15.1416C9.77941 15.1416 11.297 14.0892 11.8853 12.5228C11.9215 12.4264 11.9175 12.3215 11.8741 12.2276C11.8299 12.1316 11.7469 12.0558 11.6466 12.0195C11.2641 11.8811 11.0071 11.5152 11.0071 11.1089C11.0071 10.7026 11.2641 10.3367 11.6466 10.1983C11.747 10.162 11.8299 10.0861 11.8741 9.99019C11.9175 9.89618 11.9215 9.79137 11.8853 9.69503C11.297 8.12864 9.77941 7.07617 8.10898 7.07617C6.44466 7.07617 4.92903 8.12342 4.33751 9.68211C4.29945 9.78239 4.30329 9.89096 4.34842 9.98767C4.39386 10.0852 4.47536 10.1587 4.57793 10.1945C4.96655 10.3302 5.22768 10.6976 5.22768 11.109C5.22768 11.5203 4.9666 11.8877 4.57798 12.0234C4.47545 12.0592 4.39391 12.1327 4.34846 12.2302C4.30338 12.3269 4.29949 12.4354 4.33756 12.5358C4.92903 14.0944 6.44466 15.1416 8.10898 15.1416ZM4.64734 12.3695C4.65173 12.3602 4.66259 12.3432 4.6866 12.3348C5.20747 12.1529 5.55747 11.6602 5.55747 11.1089C5.55747 10.5575 5.20747 10.0649 4.6866 9.88299C4.66259 9.87465 4.65169 9.85766 4.64734 9.84827C4.6423 9.83746 4.6379 9.82009 4.64587 9.79911C5.1891 8.36773 6.58081 7.40601 8.10898 7.40601C9.64275 7.40601 11.0362 8.3725 11.5764 9.81098C11.5815 9.82454 11.5809 9.83837 11.5746 9.85202C11.567 9.86847 11.5524 9.88162 11.5343 9.88812C11.0217 10.0736 10.6772 10.5642 10.6772 11.1089C10.6772 11.6536 11.0217 12.1442 11.5343 12.3296C11.5524 12.3361 11.567 12.3493 11.5746 12.3657C11.5809 12.3794 11.5815 12.3932 11.5764 12.4067C11.0362 13.8452 9.6427 14.8117 8.10898 14.8117C6.58081 14.8117 5.1891 13.85 4.64587 12.4186C4.63795 12.3977 4.64234 12.3804 4.64734 12.3695Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.59961 3.80211H14.6179V1.09961H1.59961V3.80211ZM3.27241 2.64307C3.37867 2.64307 3.46481 2.55693 3.46481 2.45066C3.46481 2.3444 3.37867 2.25826 3.27241 2.25826C3.16614 2.25826 3.08 2.3444 3.08 2.45066C3.08 2.55693 3.16614 2.64307 3.27241 2.64307ZM4.30374 2.45066C4.30374 2.55693 4.21759 2.64307 4.11133 2.64307C4.00506 2.64307 3.91892 2.55693 3.91892 2.45066C3.91892 2.3444 4.00506 2.25826 4.11133 2.25826C4.21759 2.25826 4.30374 2.3444 4.30374 2.45066ZM4.9512 2.64307C5.05747 2.64307 5.14361 2.55693 5.14361 2.45066C5.14361 2.3444 5.05747 2.25826 4.9512 2.25826C4.84494 2.25826 4.75879 2.3444 4.75879 2.45066C4.75879 2.55693 4.84494 2.64307 4.9512 2.64307ZM6.23717 2.28593H13.117V2.61578H6.23717V2.28593Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 16 19',
});

export const OfficeIcon = createIcon({
  displayName: 'OfficeIcon',
  path: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.5 6.92087V13.2103C0.5 14.3149 1.39543 15.2103 2.5 15.2103H13.5C14.6046 15.2103 15.5 14.3149 15.5 13.2103V6.15771C15.5 5.05315 14.6046 4.15771 13.5 4.15771H1.28947V4.15771C0.933735 4.15771 0.707694 4.53849 0.878041 4.85079L2.2999 7.45752C2.65036 8.10005 3.3238 8.49982 4.05569 8.49982H11.106C11.8636 8.49982 12.5561 8.07182 12.8949 7.39425L13.9211 5.34193"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.44727 4.15789V3C4.44727 1.89543 5.3427 1 6.44727 1H9.55253C10.6571 1 11.5525 1.89543 11.5525 3V4.15789"
        stroke="currentColor"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 16 16',
});

export const OtherIcon = createIcon({
  displayName: 'OtherIcon',
  path: (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="0.5" width="6.27273" height="6.27273" rx="1.5" stroke="currentColor" />
      <rect x="1" y="9.22705" width="6.27273" height="6.27273" rx="1.5" stroke="currentColor" />
      <rect x="9.72754" y="0.5" width="6.27273" height="6.27273" rx="1.5" stroke="currentColor" />
      <rect x="9.72754" y="9.22705" width="6.27273" height="6.27273" rx="1.5" stroke="currentColor" />
    </svg>
  ),
  viewBox: '0 0 17 16',
});

export const ShedIcon = createIcon({
  displayName: 'ShedIcon',
  path: (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 14.5H13.5M0.5 8V18H17V8L9 1L0.5 8Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 18 19',
});

export const SolarHotWaterIcon = createIcon({
  displayName: 'SolarHotWaterIcon',
  path: (
    <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.97492 12.4907H13.9248V14.1688H0.5V12.4907H2.73746"
        stroke="currentColor"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.61914 11.3715C2.24023 9.81897 4.75782 8.26642 7.44898 8.24516M13.3658 11.9309C11.8729 9.19414 9.60522 8.22813 7.44898 8.24516M7.44898 8.24516V6.62258V6C7.44898 5.44772 7.8967 5 8.44898 5H11"
        stroke="currentColor"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6871 15.2876V17.5251M11.6871 18.6438V22M9.44969 15.2876V16.4063M9.44969 17.5251V18.6438M9.44969 19.7625V22M7.21222 15.2876V16.9657M7.21222 18.0844V19.7625M7.21222 20.8812V21.4406M4.97476 15.2876V18.6438M4.97476 19.7625V21.4406M2.7373 15.2876V17.5251M2.7373 18.6438V19.2032M2.7373 20.3219V22"
        stroke="currentColor"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4269 4.74371C17.4269 5.94445 16.4484 6.92298 15.2437 6.92298C14.043 6.92298 13.0645 5.94445 13.0645 4.74371C13.0645 3.53907 14.043 2.56055 15.2437 2.56055C16.4484 2.56055 17.4269 3.53907 17.4269 4.74371Z"
        fill="currentColor"
      />
      <path
        d="M13.8552 1.77664C13.7032 1.77664 13.5589 1.68698 13.4966 1.53883L13.0794 0.544713C12.9976 0.34589 13.0911 0.115878 13.2899 0.034009C13.4888 -0.0478597 13.7149 0.0457045 13.8006 0.244528L14.2178 1.23865C14.2997 1.43747 14.2061 1.66748 14.0073 1.74935C13.9566 1.76495 13.9059 1.77664 13.8552 1.77664Z"
        fill="currentColor"
      />
      <path
        d="M11.8863 3.74507C11.8356 3.74507 11.7849 3.73337 11.7343 3.71388L10.7401 3.29674C10.5413 3.21487 10.4477 2.98486 10.5296 2.78603C10.6115 2.58721 10.8415 2.49364 11.0403 2.57551L12.0344 2.99265C12.2333 3.07452 12.3268 3.30453 12.245 3.50336C12.1865 3.6554 12.0383 3.74507 11.8863 3.74507Z"
        fill="currentColor"
      />
      <path
        d="M10.8922 6.9355C10.7401 6.9355 10.5959 6.84584 10.5335 6.69769C10.4517 6.49887 10.5452 6.26886 10.744 6.18699L11.7382 5.76985C11.937 5.68798 12.1631 5.78154 12.2489 5.98037C12.3307 6.17919 12.2372 6.4092 12.0383 6.49107L11.0442 6.90821C10.9935 6.9277 10.9429 6.9355 10.8922 6.9355Z"
        fill="currentColor"
      />
      <path
        d="M13.443 9.48171C13.3923 9.48171 13.3416 9.47002 13.2909 9.45052C13.0921 9.36866 12.9985 9.13864 13.0804 8.93982L13.4975 7.9457C13.5794 7.74688 13.8094 7.65331 14.0082 7.73518C14.2071 7.81705 14.3006 8.04706 14.2188 8.24589L13.8016 9.24C13.7392 9.39205 13.595 9.48171 13.443 9.48171Z"
        fill="currentColor"
      />
      <path
        d="M17.0486 9.48123C16.8965 9.48123 16.7523 9.39157 16.6899 9.24342L16.2728 8.2493C16.1909 8.05048 16.2845 7.82047 16.4833 7.7386C16.6821 7.65673 16.9082 7.75029 16.994 7.94912L17.4111 8.94324C17.493 9.14206 17.3994 9.37207 17.2006 9.45394C17.146 9.47343 17.0954 9.48123 17.0486 9.48123Z"
        fill="currentColor"
      />
      <path
        d="M19.5953 6.93549C19.5446 6.93549 19.4939 6.9238 19.4432 6.90431L18.4491 6.48717C18.2503 6.4053 18.1567 6.17529 18.2386 5.97646C18.3205 5.77764 18.5505 5.68407 18.7493 5.76594L19.7434 6.18308C19.9423 6.26495 20.0358 6.49496 19.9539 6.69379C19.8916 6.84583 19.7473 6.93549 19.5953 6.93549Z"
        fill="currentColor"
      />
      <path
        d="M18.6012 3.74555C18.4491 3.74555 18.3049 3.65589 18.2425 3.50385C18.1606 3.30502 18.2542 3.07501 18.453 2.99314L19.451 2.576C19.6499 2.49413 19.876 2.5877 19.9617 2.78652C20.0436 2.98534 19.9501 3.21536 19.7512 3.29722L18.7532 3.71437C18.7025 3.73386 18.6518 3.74555 18.6012 3.74555Z"
        fill="currentColor"
      />
      <path
        d="M16.6324 1.77615C16.5817 1.77615 16.531 1.76445 16.4804 1.74496C16.2815 1.66309 16.188 1.43308 16.2698 1.23425L16.687 0.240134C16.7689 0.0413099 16.9989 -0.0522542 17.1977 0.0296144C17.3965 0.111483 17.4901 0.341495 17.4082 0.540319L16.9911 1.53444C16.9287 1.68648 16.7845 1.77615 16.6324 1.77615Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 20 23',
});

export const SpaIcon = createIcon({
  displayName: 'SpaIcon',
  path: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.0226 10.7119C17.7667 14.2301 14.8313 17.0048 11.2478 17.0048H8.75289C5.16942 17.0048 2.23404 14.2301 1.97808 10.7119H18.0226Z"
        stroke="currentColor"
      />
      <rect
        x="0.979798"
        y="9.15656"
        width="18.0404"
        height="0.959596"
        rx="0.479798"
        stroke="currentColor"
        strokeWidth="0.959596"
      />
      <path
        d="M7.08008 6.66162C6.31254 6.08586 5.83253 4.85434 6.79201 3.97475C7.9435 2.91914 7.08008 1.19192 6.79225 1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3428 6.66162C9.57523 6.08586 9.09523 4.85434 10.0547 3.97475C11.2062 2.91914 10.3428 1.19192 10.0549 1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6055 6.66162C12.8379 6.08586 12.3579 4.85434 13.3174 3.97475C14.4689 2.91914 13.6055 1.19192 13.3176 1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.18066 18.5638C3.77681 18.7873 4.91262 18.7746 4.68672 16.9351"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8135 18.5638C16.2173 18.7873 15.0815 18.7746 15.3074 16.9351"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 20 20',
});

export const StudioIcon = createIcon({
  displayName: 'StudioIcon',
  path: (
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.7692 1.65392V0.557767C18.7692 0.355832 18.6055 0.192383 18.4038 0.192383H11.4615C10.8652 0.192383 10.3344 0.479819 10.001 0.923152C10.0005 0.923152 10.0002 0.923152 10 0.923152C9.99976 0.923152 9.99951 0.923152 9.99903 0.923152C9.66555 0.479819 9.13477 0.192383 8.53846 0.192383H1.59615C1.39446 0.192383 1.23077 0.355832 1.23077 0.557767V1.65392H0.5V14.077H8.3677C8.76744 14.5252 9.35205 14.8078 10 14.8078C10.6479 14.8078 11.2323 14.5252 11.6318 14.077H19.5V1.65392H18.7692ZM1.96154 0.923152H8.53846C9.14281 0.923152 9.63461 1.41496 9.63461 2.01931V9.00205C9.63461 9.20399 9.79831 9.36743 10 9.36743C10.2017 9.36743 10.3654 9.20399 10.3654 9.00205V2.01931C10.3654 1.41496 10.8572 0.923152 11.4615 0.923152H18.0385V12.6155H11.4615C10.8655 12.6155 10.3344 12.9029 10.001 13.3462C10.0007 13.3462 10.0002 13.3462 10 13.3462C9.99976 13.3462 9.99927 13.3462 9.99903 13.3462C9.66555 12.9029 9.13453 12.6155 8.53846 12.6155H1.96154V0.923152Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 20 15',
});

export const SubboardIcon = createIcon({
  displayName: 'SubboardIcon',
  path: (
    <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.5 6.15141V1H5.58451M0.5 6.15141H5.58451M0.5 6.15141V15.0047M15.7089 6.15141V1H10.6467M15.7089 6.15141H10.6467M15.7089 6.15141V15.0047M5.58451 1V6.15141M5.58451 1H10.6467M5.58451 6.15141H10.6467M10.6467 6.15141V1M0.5 15.0047V20H5.57336M0.5 15.0047H5.57336M15.7089 15.0047V20H10.6467M15.7089 15.0047H10.6467M10.6467 15.0047V20M10.6467 15.0047H5.57336M10.6467 20H5.57336M5.57336 15.0047V20M1.88263 11.8603H3.04225M4.20188 11.8603H3.04225M3.04225 11.8603V9.13967M7.12324 11.8603H8.16021M9.19718 11.8603H8.16021M8.16021 11.8603V9.13967M12.1854 9.27347H13.2559M14.3263 9.27347H13.2559M13.2559 9.27347V11.8603"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="3.02039" cy="3.5199" r="0.423709" fill="currentColor" />
      <circle cx="3.02039" cy="17.6137" r="0.423709" fill="currentColor" />
      <circle cx="8.10437" cy="3.5199" r="0.423709" fill="currentColor" />
      <circle cx="8.10437" cy="17.6137" r="0.423709" fill="currentColor" />
      <circle cx="13.2333" cy="3.5199" r="0.423709" fill="currentColor" />
      <circle cx="13.2333" cy="17.6137" r="0.423709" fill="currentColor" />
    </svg>
  ),
  viewBox: '0 0 17 21',
});

export const TenantIcon = createIcon({
  displayName: 'TenantIcon',
  path: (
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2205 12.0615C11.2205 13.0539 10.4271 13.8482 9.46083 13.8482C8.49458 13.8482 7.70117 13.0539 7.70117 12.0615C7.70117 11.0692 8.49458 10.2749 9.46083 10.2749C10.4271 10.2749 11.2205 11.0692 11.2205 12.0615Z"
        stroke="currentColor"
      />
      <path
        d="M0.5 7.50814L1.3691 6.87286M18.5 7.50814L17.3798 6.70672M17.3798 6.70672L9.40343 1L4.57511 4.52936M17.3798 6.70672V19H13.5365V16.557C13.5558 15.8339 13.2352 14.3798 11.7983 14.3485C10.3614 14.3173 7.91631 14.3355 6.87339 14.3485C6.13949 14.4267 5.42489 15.5544 5.42489 16.557C5.42489 17.5342 5.42489 18.4723 5.42489 18.4723V19H1.3691V6.87286M1.3691 6.87286L3.03004 5.65876M3.03004 5.65876V2.09446H4.57511V4.52936M3.03004 5.65876L4.57511 4.52936"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 19 20',
});

export const UnderFloorHeatingIcon = createIcon({
  displayName: 'UnderFloorHeatingIcon',
  path: (
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.1288 6.55294C5.32581 5.98823 4.82363 4.78036 5.82743 3.91765C7.03211 2.8823 6.1288 1.18824 5.82768 1"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.67763 6.55294C8.87464 5.98823 8.37246 4.78036 9.37626 3.91765C10.5809 2.8823 9.67763 1.18824 9.37651 1"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2313 6.55294C12.4283 5.98823 11.9262 4.78036 12.93 3.91765C14.1346 2.8823 13.2313 1.18824 12.9302 1"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.28613 7.22876V16.7501C2.28614 18.6185 4.68863 18.6441 4.68865 16.7501V8.43172C4.68865 6.71682 7.09116 6.7424 7.09116 8.43172V16.7501C7.09116 18.7721 9.49368 18.5673 9.49368 16.7501V8.43172C9.49368 7.4078 11.4048 6.58876 11.8143 8.43172V16.7501C11.8143 18.5161 14.1895 18.9512 14.1895 16.7501V8.43172C14.053 7.35661 15.9914 6.17924 16.592 8.43172V10.7097M16.592 12.4245V18.0298"
        stroke="currentColor"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="1" y="5.9707" width="16.8824" height="13.5294" rx="1.5" stroke="currentColor" />
    </svg>
  ),
  viewBox: '0 0 19 20',
});

export const GridSourceIcon = createIcon({
  displayName: 'GridSourceIcon',
  path: (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_890_96839)">
        <circle cx="25" cy="25" r="21" fill="transparent" />
      </g>
      <g clipPath="url(#clip0_890_96839)">
        <path
          d="M21.4801 30.8776L19.0924 37.2449L27.8475 30.8776M21.4801 30.8776L30.2353 37.2449L27.8475 30.8776M21.4801 30.8776H27.8475M21.4801 30.8776V24.5102M21.4801 30.8776L27.4495 24.5102H21.4801M21.4801 11.3776L24.6638 7L27.8475 11.3776M21.4801 11.3776L27.4495 17.9439H21.4801M21.4801 11.3776H27.8475M21.4801 11.3776H14.7148L21.4801 17.7449M21.4801 11.3776V17.7449M27.8475 11.3776L21.4801 17.9439M27.8475 11.3776H34.2148L27.8475 18.1429M27.8475 11.3776V18.1429M27.8475 30.8776L21.4801 24.5102M27.8475 30.8776V18.1429M21.4801 24.5102L27.4495 18.1429M21.4801 24.5102V17.9439M21.4801 17.9439L27.4495 24.1122M21.4801 17.9439V17.7449"
          stroke="#9BA0A1"
          strokeWidth="0.75"
          strokeLinejoin="round"
        />
        <path
          d="M18.1016 37.7448H31.224C31.5002 37.7448 31.724 37.9687 31.724 38.2448V38.7346H17.6016V38.2448C17.6016 37.9687 17.8254 37.7448 18.1016 37.7448Z"
          fill="currentColor"
          stroke="#6B8DA0"
          strokeWidth="0.994898"
        />
        <path
          d="M15.5108 39.3368H33.8169C33.9803 39.3368 34.1128 39.4693 34.1128 39.6327C34.1128 39.7961 33.9803 39.9286 33.8169 39.9286H15.5108C15.3473 39.9286 15.2148 39.7961 15.2148 39.6327C15.2148 39.4693 15.3473 39.3368 15.5108 39.3368Z"
          stroke="#ABBAC3"
          strokeWidth="0.795918"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_890_96839"
          x="0"
          y="0"
          width="50"
          height="50"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_890_96839" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_890_96839" result="shape" />
        </filter>
        <clipPath id="clip0_890_96839">
          <path
            d="M7 25C7 15.0589 15.0589 7 25 7V7C34.9411 7 43 15.0589 43 25V25C43 34.9411 34.9411 43 25 43V43C15.0589 43 7 34.9411 7 25V25Z"
            fill="currentColor"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 50 50',
});

export const SolarSourceIcon = createIcon({
  displayName: 'SolarSourceIcon',
  path: (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_675_139862)">
        <circle cx="25" cy="25" r="21" fill="transparent" />
      </g>
      <path
        d="M26.6016 15.8739C26.6016 16.5471 26.058 17.0871 25.3884 17.0871H22.098C21.4248 17.0871 20.8848 16.5435 20.8848 15.8739C20.8848 15.3591 21.2052 14.9163 21.6588 14.7399C21.6264 14.6175 21.6084 14.4879 21.6084 14.3511C21.6084 13.4871 22.314 12.7851 23.178 12.7851C24.042 12.7851 24.744 13.4871 24.744 14.3511C24.744 14.4555 24.7368 14.5563 24.7152 14.6571H25.3884C26.058 14.6607 26.6016 15.2007 26.6016 15.8739Z"
        fill="#C0D8E7"
      />
      <path d="M23.7441 22.7751H26.7105L26.4297 20.7123H23.7441V22.7751Z" fill="#ABBAC3" />
      <path d="M19.7188 25.1979H23.0235V23.4951H19.9527L19.7188 25.1979Z" fill="#ABBAC3" />
      <path d="M23.7441 23.4951V25.1979H27.0453L26.8113 23.4951H23.7441Z" fill="#ABBAC3" />
      <path d="M23.0247 20.7123H20.3391L20.0547 22.7751H23.0247V20.7123Z" fill="#ABBAC3" />
      <path d="M23.7441 27.6242H27.3801L27.1461 25.9178H23.7441V27.6242Z" fill="#ABBAC3" />
      <path
        d="M32.2963 28.3443H28.2031L28.4875 30.4071H32.0227C32.4475 30.4071 32.7571 30.0039 32.6419 29.5935L32.2963 28.3443Z"
        fill="#ABBAC3"
      />
      <path d="M18.8941 25.9178H15.1321L14.6641 27.6242H18.6601L18.8941 25.9178Z" fill="#ABBAC3" />
      <path d="M19.2289 23.4951H15.7981L15.3301 25.1979H18.9949L19.2289 23.4951Z" fill="#ABBAC3" />
      <path d="M23.0232 28.3443H19.2864L19.002 30.4071H23.0232V28.3443Z" fill="#ABBAC3" />
      <path
        d="M19.3264 22.7751L19.6108 20.7123H17.0548C16.7632 20.7123 16.5112 20.9067 16.4356 21.1839L16 22.7751H19.3264Z"
        fill="#ABBAC3"
      />
      <path
        d="M18.5599 28.3443H14.4667L14.1247 29.5935C14.0131 30.0039 14.3191 30.4071 14.7439 30.4071H18.2791L18.5599 28.3443Z"
        fill="#ABBAC3"
      />
      <path
        d="M27.437 22.7751H30.767L30.3315 21.1839C30.2559 20.9031 30.0002 20.7123 29.7122 20.7123H27.1562L27.437 22.7751Z"
        fill="#ABBAC3"
      />
      <path d="M31.6311 25.9178H27.8691L28.1031 27.6242H32.0991L31.6311 25.9178Z" fill="#ABBAC3" />
      <path d="M27.4773 28.3443H23.7441V30.4071H27.7617L27.4773 28.3443Z" fill="#ABBAC3" />
      <path d="M27.7731 25.1979H31.4343L30.9663 23.4951H27.5391L27.7731 25.1979Z" fill="#ABBAC3" />
      <path d="M23.0247 27.6242V25.9178H19.6227L19.3887 27.6242H23.0247Z" fill="#ABBAC3" />
      <path d="M24.3495 31.127H22.4199V32.7434H24.3495V31.127Z" fill="#9BA0A1" />
      <path
        d="M27.2185 34.1079V34.8999H19.5469V34.1079C19.5469 33.7515 19.8349 33.4635 20.1913 33.4635H26.5741C26.9305 33.4635 27.2185 33.7515 27.2185 34.1079Z"
        fill="#6B8DA0"
      />
      <path
        d="M35.1339 15.8776C35.1339 16.9864 34.2303 17.89 33.1179 17.89C32.0091 17.89 31.1055 16.9864 31.1055 15.8776C31.1055 14.7652 32.0091 13.8616 33.1179 13.8616C34.2303 13.8616 35.1339 14.7652 35.1339 15.8776Z"
        fill="#FFC634"
      />
      <path
        d="M31.8375 13.1381C31.6971 13.1381 31.5639 13.0553 31.5063 12.9185L31.1211 12.0005C31.0455 11.8169 31.1319 11.6045 31.3155 11.5289C31.4991 11.4533 31.7079 11.5397 31.7871 11.7233L32.1723 12.6413C32.2479 12.8249 32.1615 13.0373 31.9779 13.1129C31.9311 13.1273 31.8843 13.1381 31.8375 13.1381Z"
        fill="#FFC634"
      />
      <path
        d="M30.0184 14.956C29.9716 14.956 29.9248 14.9452 29.878 14.9272L28.96 14.542C28.7764 14.4664 28.69 14.254 28.7656 14.0704C28.8412 13.8868 29.0536 13.8004 29.2372 13.876L30.1552 14.2612C30.3388 14.3368 30.4252 14.5492 30.3496 14.7328C30.2956 14.8732 30.1588 14.956 30.0184 14.956Z"
        fill="#FFC634"
      />
      <path
        d="M29.1007 17.9006C28.9603 17.9006 28.8271 17.8178 28.7695 17.681C28.6939 17.4974 28.7803 17.285 28.9639 17.2094L29.8819 16.8242C30.0655 16.7486 30.2743 16.835 30.3535 17.0186C30.4291 17.2022 30.3427 17.4146 30.1591 17.4902L29.2411 17.8754C29.1943 17.8934 29.1475 17.9006 29.1007 17.9006Z"
        fill="#FFC634"
      />
      <path
        d="M31.4559 20.2515C31.4091 20.2515 31.3623 20.2407 31.3155 20.2227C31.1319 20.1471 31.0455 19.9347 31.1211 19.7511L31.5063 18.8331C31.5819 18.6495 31.7943 18.5631 31.9779 18.6387C32.1615 18.7143 32.2479 18.9267 32.1723 19.1103L31.7871 20.0283C31.7295 20.1687 31.5963 20.2515 31.4559 20.2515Z"
        fill="#FFC634"
      />
      <path
        d="M34.7848 20.2514C34.6444 20.2514 34.5112 20.1686 34.4536 20.0318L34.0684 19.1138C33.9928 18.9302 34.0792 18.7178 34.2628 18.6422C34.4464 18.5666 34.6552 18.653 34.7344 18.8366L35.1196 19.7546C35.1952 19.9382 35.1088 20.1506 34.9252 20.2262C34.8748 20.2442 34.828 20.2514 34.7848 20.2514Z"
        fill="#FFC634"
      />
      <path
        d="M37.1356 17.9008C37.0888 17.9008 37.042 17.89 36.9952 17.872L36.0772 17.4868C35.8936 17.4112 35.8072 17.1988 35.8828 17.0152C35.9584 16.8316 36.1708 16.7452 36.3544 16.8208L37.2724 17.206C37.456 17.2816 37.5424 17.494 37.4668 17.6776C37.4092 17.818 37.276 17.9008 37.1356 17.9008Z"
        fill="#FFC634"
      />
      <path
        d="M36.2179 14.956C36.0775 14.956 35.9443 14.8732 35.8867 14.7328C35.8111 14.5492 35.8975 14.3368 36.0811 14.2612L37.0027 13.876C37.1863 13.8004 37.3951 13.8868 37.4743 14.0704C37.5499 14.254 37.4635 14.4664 37.2799 14.542L36.3583 14.9272C36.3115 14.9452 36.2647 14.956 36.2179 14.956Z"
        fill="#FFC634"
      />
      <path
        d="M34.3993 13.1379C34.3525 13.1379 34.3057 13.1271 34.2589 13.1091C34.0753 13.0335 33.9889 12.8211 34.0645 12.6375L34.4497 11.7195C34.5253 11.5359 34.7377 11.4495 34.9213 11.5251C35.1049 11.6007 35.1913 11.8131 35.1157 11.9967L34.7305 12.9147C34.6729 13.0551 34.5397 13.1379 34.3993 13.1379Z"
        fill="#FFC634"
      />
      <defs>
        <filter
          id="filter0_d_675_139862"
          x="0"
          y="0"
          width="50"
          height="50"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_675_139862" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_675_139862" result="shape" />
        </filter>
      </defs>
    </svg>
  ),
  viewBox: '0 0 50 50',
});

export const HomeIcon = createIcon({
  displayName: 'HomeIcon',
  path: (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M27.6682 12.7744L23.5044 8.908V2.57118H18.7074V4.4516L13.9104 0L0.152673 12.7744C-0.0392065 12.9567 -0.0535974 13.2589 0.128688 13.4507C0.310973 13.6426 0.613183 13.657 0.805063 13.4747L2.39766 12.0021V28H10.0728H17.748H25.4232V12.0021L27.0158 13.4795C27.1069 13.5659 27.2269 13.609 27.342 13.609C27.4715 13.609 27.601 13.5563 27.6922 13.4555C27.8744 13.2589 27.8601 12.9567 27.6682 12.7744ZM19.6668 3.53058H22.545V8.01576L19.6668 5.34384V3.53058ZM11.0322 27.0358V16.9334C11.0322 16.6839 11.2337 16.4824 11.4832 16.4824H16.3425C16.5919 16.4824 16.7934 16.6839 16.7934 16.9334V27.0358H11.0322ZM24.4638 27.0358H17.748V16.9334C17.748 16.1562 17.1148 15.523 16.3377 15.523H11.4832C10.706 15.523 10.0728 16.1562 10.0728 16.9334V27.0358H3.35706V11.1098L13.9104 1.30958L20.7605 7.67038L23.5044 10.2176L24.4638 11.1098V27.0358Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 28 28',
});

// eslint-enable max-len
